export default __webpack_public_path__ + "static/media/BriannaLovelace.a9fc0dc3.png";